import { Component } from 'react';
import { withTranslation } from 'react-i18next';
import Loading from '../../../../components/Loading';
import ReactModal from '../../../../components/Modal';
import ReactSelect from '../../../../components/ReactSelect';
import { BULK_FREQUENCY_OPTIONS } from '../../create/utils';
import { bulkUpdateFrequency } from '../query';

class ChangeFrequency extends Component {
    constructor() {
        super();

        this.onSubmit = this.onSubmit.bind(this);
        this.onSelect = this.onSelect.bind(this);
        this.onClose = this.onClose.bind(this);

        this.state = {
            frequency: null,
            isLoading: false,
            error: '',
        };
    }

    onSelect(frequency) {
        this.setState({ frequency, error: '' });
    }

    onClose() {
        this.setState({ frequency: null, error: '' });
        this.props.onClose();
    }

    async onSubmit() {
        try {
            this.setState({ isLoading: true, error: '' });
            const response = await bulkUpdateFrequency({
                frequency: this.state.frequency,
                ids: this.props.selectedItems,
            });
            const data = await response.json();
            if (response.status === 200) {
                if (this.props.getPrompts) this.props.getPrompts();
                this.props.onRemoveAllSelected(true);
                this.onClose();
            } else {
                this.setState({
                    error: data?.detail ?? this.props.t('global.something_went_wrong'),
                });
            }
        } catch (err) {
            this.setState({ error: this.props.t('global.something_went_wrong') });
        } finally {
            this.setState({ isLoading: false });
        }
    }

    render() {
        const { t } = this.props;
        const options = BULK_FREQUENCY_OPTIONS(t);

        return (
            <ReactModal
                modalState={this.props.isOpen}
                className="ai-tracking-edit-keyword-container ai-tracking-modal"
                onClose={this.onClose}
            >
                <h3>{t('ai_tracking.global.change_frequency')}</h3>
                <div className="ai-tracking-edit-keyword-container-body ai-tracking-modal-body px-12">
                    <ReactSelect
                        options={options}
                        value={options.find((x) => x.value === this.state.frequency) ?? null}
                        label={
                            <div>
                                {t('ai_tracking.add_keyword.frequency')}{' '}
                                <span className="text-danger">*</span>
                            </div>
                        }
                        labelClassname="ai-tracking-create-label"
                        placeholder={t('ai_tracking.add_keyword.frequency')}
                        onChange={this.onSelect}
                        isSearchable={false}
                        blurInputOnSelect={true}
                        classname="mx-0"
                    />
                    {this.state.error && <div className="error-message">{this.state.error}</div>}
                </div>
                <div className="btn-wrapper ai-tracking-modal-footer">
                    <button
                        className="button button-filled button-primary width-sm btn d-flex align-items-center justify-content-center"
                        disabled={this.state.isLoading || !this.state.frequency}
                        onClick={this.onSubmit}
                    >
                        <span style={{ marginRight: '5px' }}>
                            {t('ai_tracking.keyword_manager.edit_keyword.save')}
                        </span>
                        {this.state.isLoading && <Loading onlyPreloader />}
                    </button>
                    <button
                        type="button"
                        className="button button-outline button-primary width-sm btn"
                        onClick={this.onClose}
                        style={{ lineHeight: 'unset' }}
                    >
                        {t('ai_tracking.keyword_manager.edit_keyword.close')}
                    </button>
                </div>
            </ReactModal>
        );
    }
}

export default withTranslation()(ChangeFrequency);
